import { FsSetFormatBase } from "db/model/match/Set/FsSetFormat";
import { SetFormatBase } from "model/Match/Set/SetFormat";

export const mapSetFormatBase = (
  fsModel: FsSetFormatBase
): SetFormatBase | undefined => {
  if (!fsModel.driversPerTeam || !fsModel.numWinners) {
    return undefined;
  }

  return {
    driversPerTeam: fsModel.driversPerTeam,
    numWinners: fsModel.numWinners,
  };
};
